import { PropsWithChildren, FC, useCallback, useState } from 'react'
import { createPortal } from 'react-dom'
import cn from 'classnames'

import { PopupWrapper } from 'components/app/popup'
import IconClose from 'images/icon-close-blue.svg'
import BackIcon from 'images/arrow-back.svg'
import useWindowWidth from 'hooks/use-window-width'

import styles from './styles.module.scss'

interface Props {
  heading: string
  onClose: () => void
  subtitle?: string
  className?: string
  parrentIsClosing?: boolean
  isDark?: boolean
  isWithoutClose?: boolean
  crossIconBtnStyle?: string
  titleClassName?: string
  subtitleClassName?: string
  mainClassName?: string
  hasBackBtn?: boolean
  onBack?: () => void
}

const Popup: FC<PropsWithChildren<Props>> = ({
  onClose,
  heading,
  subtitle,
  className,
  children,
  parrentIsClosing,
  isDark,
  isWithoutClose,
  crossIconBtnStyle,
  titleClassName,
  subtitleClassName,
  mainClassName,
  hasBackBtn = false,
  onBack,
}) => {
  const [isClosing, setIsClosing] = useState(false)
  const width = useWindowWidth()

  const onClosePopup = useCallback(() => {
    if (width < 766) {
      setIsClosing(true)
      setTimeout(() => onClose(), 300)
      return
    }

    onClose()
  }, [width])

  return createPortal(
    <PopupWrapper
      onClose={onClosePopup}
      classNames={[
        styles.container,
        (isClosing || parrentIsClosing) && styles.closedContainer,
        isDark && styles.dark,
        className,
      ]}
    >
      <div className={styles.header}>
        <h2 className={cn(styles.title, titleClassName, 
          {[styles['title__with-back-btn']]: hasBackBtn })}>
          {heading}
        </h2>

        {subtitle && <div className={cn(styles.subtitle, subtitleClassName)}>{subtitle}</div>}
      </div>

      <div className={cn(styles.main, mainClassName || className)}>{children}</div>

      {!isWithoutClose && (
        <button className={cn(styles.btn, crossIconBtnStyle)} type="button" onClick={onClosePopup}>
          <img src={IconClose} alt="close" />
        </button>
      )}

      {hasBackBtn && (
        <button className={cn(styles['back-btn'])} type="button" onClick={onBack}>
          <img src={BackIcon} alt="back" />
        </button>
      )}
    </PopupWrapper>,
    document?.body,
  )
}

export default Popup
